module.exports = __webpack_public_path__ + "9db83250371cf7cc6f15f32f8872a8d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/pages/example-page_3.jpg
// module id = 871
// module chunks = 0